<template>
  <Breadcrumbs
      title="Trust Eligible Dealer List"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Trust Management', path: '/trust-management' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <trustDealerListTable/>
    </div>
  </div>
</template>

<script>

import trustDealerListTable from "@/pages/master_data/trust_management/trustDealerListTable.vue";

export default {
  components: {
    trustDealerListTable
  }
}

</script>